import { TableColumn } from './tableTypes'
import { createColumns } from './columnGroupCreator'

import { FakeApiCell } from '../components/FakeApiCell'
import { UserSyncCell } from '../components/UserSyncCell'
import { UserImpersonateCell } from '../components/UserImpersonateCell'
import { AdminCommentCell } from '../components/Admin/tableCells/AdminCommentCell'
import { PaymentSourceCell } from '../components/Admin/tableCells/PaymentSourceCell'
import { LastPaymentDateCell } from '../components/Admin/tableCells/LastPaymentDateCell'
import { SubscriptionTypeCell } from '../components/Admin/tableCells/SubscriptionTypeCell'
import { TableDateCell, TableDateCellLastOrder } from '../components/tableCells/TableDateCell'
import { SubscriptionStatusCell } from '../components/Admin/tableCells/SubscriptionStatusCell'
import { SubscriptionEndDateCell } from '../components/Admin/tableCells/SubscriptionEndDateCell'
import { AllowAutoSupplyOptionSetting } from '../components/Admin/tableCells/AllowAutoSupplyOptionSetting'

import { appTheme } from '../common/appTheme'
import { emDash } from '../common/stringUtility'

import { UserModel } from '../server/mpsklad_core/Models/UserModel'

export type UserColumnId = keyof UserModel | 'impersonate' | 'allowAutoSupplyOptionSetting'

export type UserColumn = TableColumn<UserColumnId, UserModel>

export const userColumns: UserColumn[] =
  createColumns<UserColumnId, UserModel>({
    id: 'email',
    title: 'Email'
  }, {
    id: 'id',
    title: 'ID'
  }, {
    id: 'createdAt',
    title: 'Дата регистрации',
    sortable: true,
    CellComponent: TableDateCell
  }, {
    id: 'name',
    title: 'Имя'
  }, {
    id: 'phone',
    title: 'Телефон'
  }, {
    id: 'hasPaidMsApp',
    title: 'Платное приложение МС',
    sortable: true
  }, {
    id: 'lastOrderDateUnix',
    title: 'Последний заказ МС',
    sortable: true,
    CellComponent: TableDateCellLastOrder
  }, {
    id: 'ozonAccountCount',
    title: 'Аккаунты Ozon',
    sortable: true
  }, {
    id: 'wbAccountCount',
    title: 'Аккаунты Wildberries',
    sortable: true
  }, {
    id: 'yandexMarketAccountCount',
    title: 'Аккаунты Yandex Market',
    sortable: true
  }, {
    id: 'allowSync',
    title: 'Разрешить синхронизацию',
    sortable: true,
    CellComponent: UserSyncCell
  }, {
    id: 'isUsingFakeApi',
    title: 'Использовать кэш',
    sortable: true,
    CellComponent: FakeApiCell
  }, {
    id: 'msTariff',
    title: 'Тариф МоегоСклада',
    accessor: _ => _.msTariff ?? emDash,
    sortable: true
  }, {
    id: 'subscriptionType',
    title: 'Тип подписки',
    CellComponent: SubscriptionTypeCell
  }, {
    id: 'lastPaymentDate',
    title: 'Даты оплаты',
    sortable: true,
    CellComponent: LastPaymentDateCell
  }, {
    id: 'paymentSource',
    title: 'Источник оплаты',
    CellComponent: PaymentSourceCell
  }, {
    id: 'subscriptionEndDate',
    title: 'Дата окончания подписки',
    sortable: true,
    CellComponent: SubscriptionEndDateCell
  }, {
    id: 'subscriptionStatus',
    title: 'Статус подписки',
    CellComponent: SubscriptionStatusCell
  }, {
    id: 'adminComment',
    title: 'Комментарий',
    CellComponent: AdminCommentCell
  }, {
    id: 'salesModels',
    title: 'Модели продаж',
    accessor: _ => _.salesModels ?? emDash
  }, {
    id: 'ordersLast30Days',
    title: 'Кол-во заказов за 30 дней',
    sortable: true
  }, {
    id: 'isAtRisk',
    title: 'В зоне риска',
    cellStyle: row => row.isAtRisk ? styles.isAtRisk : undefined,
    sortable: true
  }, {
    id: 'allowAutoSupplyOptionSetting',
    title: 'Настройка разрешения авто-перемещений',
    CellComponent: AllowAutoSupplyOptionSetting
  }, {
    id: 'impersonate',
    title: 'Посмотреть',
    CellComponent: UserImpersonateCell
  })

const styles = {
  isAtRisk: {color: appTheme.palette.warning.dark}
}